module.exports = __webpack_public_path__ + "img/JJ-update-payment.8314dd61.png";